Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.HashtagFilterView extends Backbone.View
  template: JST["backbone/templates/monitoring/filters/hashtag/hashtag_filter"]

  events:
    'click #add-hashtag': '_apply'

  initialize: (@options = {}) ->
    @searchQuery = @options.searchQuery
    @facet = @options.facet

  destroy: () ->
    this.remove()
    return false

  render: ->
    @$el.html(@template())
    return this

  _apply: (event) =>
    text = @$el.find("#hashtag").val()
    text = if text.indexOf('#') == 0 then text.substring(1) else text
    @searchQuery.addHashtag(text);
    @eventAggregator.trigger('searchQueryChanged', @searchQuery)
